import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewReviewPageNew from "../../components/Review/ViewReviewPageNew";

const ViewReviewPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="View"   title2="Review Management" 
        link2="/review" 
         />

        <ViewReviewPageNew />
      </MasterLayout>
    </>
  );
};

export default ViewReviewPage;
